import React from "react"

const Footer = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 p-1 px-8 font-serif text-left bg-slate-400 shadow-white">
      <p className="m-1 text-sm text-center">Note Moko Copyright 2022</p>
    </div>
  )
}

export default Footer
